import React, { useState, useEffect, useMemo } from 'react';
import { HostProvider } from '../../contexts/Host'
import { ShopProvider } from '../../contexts/Shop'
import { CustomerProvider } from '../../contexts/Customer'
import ClassroomRegistrations from './ClassroomRegistrations'
import {SearchProvider} from '@thinkwell/react.common';
import {AppProvider} from '@thinkwell/react.polaris';

export default function Index(props) {
  return (<AppProvider>
      <HostProvider value={props.host}>
      <ShopProvider value={props.shop_name}>
      <CustomerProvider value={props.customer}>
      <SearchProvider>
      <ClassroomRegistrations sections={props.sections} />
    </SearchProvider></CustomerProvider></ShopProvider></HostProvider></AppProvider>)
}
